import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { V2RoutingModule } from './v2-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, V2RoutingModule],
})
export class V2Module {}
